import { AutoExposureBiProvider, AutoExposureBiProviderDisplayName } from '../dbt-dag';

type AutoExposureIconProps = {
  className?: string;
  biProvider: AutoExposureBiProvider | null;
};

export const AutoExposureIcon = ({ className, biProvider }: AutoExposureIconProps) => {
  if (!biProvider) return null;
  const src = `https://public.cdn.getdbt.com/images/logos/external/${biProvider}.svg`;
  const alt = AutoExposureBiProviderDisplayName[biProvider];

  return <img src={src} alt={alt} className={className} />;
};
